const target = 'rankingTeam'
export default {
  list: {
    config: {
      url: `/${target}/page`,
      method: 'post'
    }
  },
  findWaitingByUserId: {
    config: {
      url: `/${target}/findWaitingByUserId`,
      method: 'get'
    }
  },
  calling: {
    config: {
      url: `/${target}/calling`,
      method: 'get'
    }
  },
  cancel: {
    config: {
      url: `/${target}/cancel`,
      method: 'get'
    }
  },
  eating: {
    config: {
      url: `/${target}/eating`,
      method: 'get'
    }
  },
  passed: {
    config: {
      url: `/${target}/passed`,
      method: 'get'
    }
  },
  currentCalling: {
    config: {
      url: `/${target}/currentCalling`,
      method: 'get'
    }
  }
}
